import { useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import commonLabels from "../../common/labels/common_en.json";
import "../../styles/candidate_nav.css";
export default function ApplicationFooter() {
  const [uiVersion, setUiVersion] = useState('');
  let { accessToken, web_app_version } = useSelector(state => state.loginReducer, shallowEqual);
  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";


  /*
  ---------- version.txt should be in public folder then this code will work---------
  useEffect(() => {
  fetch('/version.txt') 
    .then((res) => res.text())
    .then((text) => {
      setUiVersion(text.trim());
    })
    .catch((err) => console.error('Error reading version file:', err));
}, []);

*/

  return (
    accessToken || (session && session?.jwtResponse?.token) ?
      ""
      :
      <div className="footer d-flex justify-content-between res-footer ">
        <div className=" text-center">
          <span>{commonLabels.COMMON.DISCLAIMER}</span>
          <br />
          <span>   {web_app_version} </span> 
        </div>
        <div className="text-center">
          <span>{commonLabels.COMMON.OFFICIAL_WEB_NOTE_1}<br />{commonLabels.COMMON.OFFICIAL_WEB_NOTE_2}</span>
        </div>
        {/* <div className="col-sm-1 text-center mt-1 f10" >
              {process.env.REACT_APP_VERSION} {apiRepoVersion ? apiRepoVersion : ''}
            </div> */}
        <div className="col-sm-1 text-center mt-1 f12 " >
          {/* {web_app_version} */}
        </div>
      </div>
  )
}
